/**
 * Contact Container Text Animation
 * Alternates between two service descriptions every 2 seconds
 */

document.addEventListener('DOMContentLoaded', function() {
  const animatedTexts = document.querySelectorAll('.animated-text');
  
  animatedTexts.forEach(function(container) {
    const desc1 = container.dataset.desc1;
    const desc2 = container.dataset.desc2;
    
    // Only proceed if both descriptions exist
    if (!desc1 || !desc2) {
      console.warn('Contact container animation: Missing service descriptions');
      return;
    }
    
    // Create both text elements
    const text1 = document.createElement('p');
    text1.className = 'animated-text-item active';
    text1.innerHTML = '<span class="dot-indicator"></span>' + desc1;
    
    const text2 = document.createElement('p');
    text2.className = 'animated-text-item';
    text2.innerHTML = '<span class="dot-indicator"></span>' + desc2;
    
    // Clear container and add both elements
    container.innerHTML = '';
    container.appendChild(text1);
    container.appendChild(text2);
    
    // Start animation
    let currentText = 1;
    setInterval(function() {
      const activeText = container.querySelector('.active');
      const nextText = activeText.nextElementSibling || container.firstElementChild;
      
      // Remove active class from current text
      activeText.classList.remove('active');
      
      // Add active class to next text
      nextText.classList.add('active');
      
      // Toggle current text counter
      currentText = currentText === 1 ? 2 : 1;
    }, 5000); // Change every 5 seconds
  });

  // Tidio Chat API Integration
  function onTidioChatApiReady() {
    window.tidioChatApi.hide();
    window.tidioChatApi.on("close", function() {
      window.tidioChatApi.hide();
    });
  }
  
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  }
  
  // Add click handler for chat button
  const chatButton = document.querySelector(".chat-button");
  if (chatButton) {
    chatButton.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent default link behavior
      if (window.tidioChatApi) {
        window.tidioChatApi.show();
        window.tidioChatApi.open();
      } else {
        console.warn('Tidio chat API not available');
      }
    });
  }
});
